import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomTable from "../../../../components/table/table";
import ResourseCard from "../../../../components/page/tiles/resourcecard";
import { download_expert_man_power_file, user_get_manpower_details } from "../../user.api";

import "../style.css";
import BreadCrumbsComp from "../../../../components/navigator/breadcrumbs";
import Loader from "../../../../components/loader/loader";
let count = 100;
export default function ResourcePersonalDetails(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const selectedParam = useParams();
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const getDetails = (id) => {
    user_get_manpower_details(id).then((res) => {
      let tdata = res.data[0];

      setData(tdata);
      setIsActive(false);
    });
  };
  useEffect(() => {
    getDetails(selectedParam.id);
  }, []);
  const handleDownloadResume = (data) => {
    let path = `${result}${data}`;
    window.open(path, "_blank");
  };
  const handleDownloadDocument = async (id) => {
  if (!id) {
    console.error("User ID is missing for download");
    return;
  }

  try {
    const response = await download_expert_man_power_file(id);

    // Extract the file URL from the response
    const fileUrl = response?.url;

    if (!fileUrl) {
      console.error("Invalid response: No URL found in API response.");
      return;
    }

    // Open the file in a new tab
    const newTab = window.open(fileUrl, "_blank");

    // Handle cases where the browser blocks pop-ups
    if (!newTab) {
      alert("Popup blocked! Please allow popups for this site.");
    }
  } catch (error) {
    console.error("Error downloading file:", error);
  }
  };
  const handleDownload = (dt) => {
    let path = `${result}${dt.file_upload_certificate}`;
    window.open(path, "_blank");
  };
  const handleExpDownload = (dt) => {
    let path = `${result}${dt.experience_certificate}`;
    window.open(path, "_blank");
  };

  return (
    <div className="tender bg-tender">
      <Loader open={isActive} />
      <BreadCrumbsComp section="expertManpower_details" />
      <div className="container p-50">
        <div className="res-page-cont-details">
          <div className="res-det-con">
            <div className="row tender-head ">
              <h4> Expert Manpower Details </h4>
              <div>
                <div className="container-ul">
                  <hr className="top hr" />
                  <hr className="bottom hr" />
                </div>
              </div>
            </div>
            <div className="row ">
              <div className="col-xs-12 ">
                <div className="profile-box ">
                  <div className="res-bannerContainer d-flex ">
                    {/* Banner image removed for cleaner card layout */}
                    <div className="resbandata">
                      <div className="res-ban-data">
                        <div>
                          <img
                            src={`${result}${data?.photo}`}
                            className="res-profile-img"
                            alt=""
                          />
                        </div>
                        <div className="profile-res-con">
                          <div className="res-person-name">
                            {data.title ? data.title + "." : "Mr."}{" "}
                            {data.first_name ?? ""} {data.last_name ?? ""}
                          </div>
                          <div className="qualification-container">
                            <div className="res-exp mb-1">Expert in</div>
                            <div className="expertise-tags">
                              {(data?.area_of_expertise || []).map((item, index) => (
                                <span key={index} className="expertise-tag">
                                  {item.expertise_name}
                                </span>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="res-about-sec">
                    <div className="res-abo-head">About</div>
                    <hr />
                    <div className="res-about-cont details-card">
                      <div className="row">
                        <div className="col-xs-11 col-md-4">Email</div>
                        <div className="col-xs-1 col-md-1">:</div>
                        <div className="col-xs-12 col-md-7">{data?.email}</div>

                        <div className="col-xs-11 col-md-4">Category</div>
                        <div className="col-xs-1 col-md-1">:</div>
                        <div className="col-xs-12 col-md-7">
                          {data?.category}
                        </div>

                        <div className="col-xs-11 col-md-4">Age</div>
                        <div className="col-xs-1 col-md-1">:</div>
                        <div className="col-xs-12 col-md-7">
                          {data?.date_of_birth}
                        </div>

                        <div className="col-xs-11 col-md-4">Gender</div>
                        <div className="col-xs-1 col-md-1">:</div>
                        <div className="col-xs-12 col-md-7">
                          {data?.gender == 1
                            ? "Male"
                            : data?.gender == 2
                            ? "Female"
                            : "Others"}
                        </div>
                        <div className="col-xs-11 col-md-4">Resume</div>
                        <div className="col-xs-1 col-md-1">:</div>
                        <div className="col-xs-12 col-md-7">
                          <button
                            className="btn btn-approved btn-success mt-2"
                            onClick={() => handleDownloadResume(data?.resume)}
                          >
                            Download Resume
                          </button>
                        </div>

                        {/* <div className="col-xs-11 col-md-4">
                          Area of Interest
                        </div>
                        <div className="col-xs-1 col-md-1">:</div>
                        <div className="col-xs-12 col-md-7">
                          {data?.area_of_interest && (
                            <>
                              {data?.area_of_interest?.map((item, index) => (
                                <>
                                  {index !== 0 && <>&nbsp;|&nbsp;</>}
                                  {item.expertise_name}
                                </>
                              ))}
                            </>
                          )}
                        </div> */}

                        <div className="row-padding">
                          <div className="col-12 max-bold">
                            Educational Qualification
                          </div>

                          <div className="col-12  overflow-auto">
                            {" "}
                            <CustomTable
                              className="areatable"
                              {...props}
                              columns={[
                                {
                                  title: " Examination passed",
                                  field: "examination_passed",
                                },
                                {
                                  title: "Board/University",
                                  field: "board_of_university",
                                },
                                {
                                  title: "Year of Passing",
                                  field: "year_of_pass",
                                },
                                { title: "Mark/grade", field: "mark_grade" },
                                { title: "Certificate", field: "file_upload_certificate",type: "download" },

                              ]}
                              data={data?.education ?? []}
                              handleDownload={handleDownload}

                            />
                          </div>
                        </div>
                        <div className="row-padding">
                          <div className="col-12  max-bold">
                            Experience Details
                          </div>

                          <div className="col-12 overflow-auto">
                            {" "}
                            <CustomTable
                              className="areatable"
                              {...props}
                              columns={[
                                {
                                  title: "Organization",
                                  field: "organization_name",
                                },
                                {
                                  title: "Experience (Yr.)",
                                  field: "experience",
                                },
                                {
                                  title: "Nature of  Work",
                                  field: "nature_of_work",
                                },
                                { title: "Designation", field: "designation" },
                                { title: "Experience certificate", field: "experience_certificate",type: "download",
                                },

                              ]}
                              data={data?.experience ?? []}
                              handleDownload={handleExpDownload}

                            />
                          </div>
                        </div>
                        <div className=" flex align-center">
                          <button
                            className="btn btn-approve btn-success"
                            onClick={(e) => handleDownloadDocument(data.user_id)}
                          >
                            Download Documents
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
